import { render, staticRenderFns } from "./PchPurchaseCreditNoteList.vue?vue&type=template&id=3afb80fa&lang=pug&"
import script from "./PchPurchaseCreditNoteList.vue?vue&type=script&lang=js&"
export * from "./PchPurchaseCreditNoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchPurchaseCreditNoteList.vue"
export default component.exports